import styled from 'styled-components';

import theme from '$/assets/theme';

const StyledValue = styled.span`
  color: ${theme.colors.grey7};
  font-size: 13px;
  letter-spacing: 0.1px;
  margin-top: 12px;
`;

export default StyledValue;
